<style>
/* ----------------- actions start ------------*/

/* new campaigns start */
.Start_A_New_Campaign_Class {
  background: #78B173;
  cursor: pointer;
}
.Current_Campaigns_Class {
  background: #68AA9B;
  cursor: pointer;
}

.spacer {
  width: 100%;
  height: 50px;
}


/* current campaigns end */
/* view tv spots starts */

  /* fill: rgba(139,98,188,1);*/


/*-------------------actions end -----------------------*/
</style>

<script>

import { Col, Container, Row } from "sveltestrap";

function changeToTvSpots() {
  window.location.href = "#/advertiser/tv-spots"
}

function changeToCampaigns() {
  window.location.href = "#/advertiser/campaigns"
}

function changeToUploadAd() {
  window.location.href = "#/advertiser/upload-ad"
}

export function init() {}
</script>
<Container>
  <Row>
    <div class="Page_Title">
      <span>Welcome, {window.getBusinessName()}</span>
    </div>
  </Row>
</Container>

<Container>
  <Row>
    <div class="Action_Wrapper">
    <div class="Start_A_New_Campaign_Class Home_Actions" on:click={changeToUploadAd}>
      <div class="header">Start A New Campaign</div>
      <div class="New_Campaign_Icon_Class">
        <img style="width: 100%; height:auto;" src="static/icons/StartANew_CampaignAD.png" alt="New Campaign">
      </div>
    </div>
    <div class="Current_Campaigns_Class Home_Actions" on:click={changeToCampaigns}>
      <div class="header">Current Campaigns</div>
      <div>
        <img style="width:100%; height:auto;" src="static/icons/Current_CampaignsAD.png" alt="Current Campaigns">
      </div>
      </div>
    </div>
  </Row>
</Container>
<!-- <div class="View_TV_Spots_Class Home_Actions" on:click={changeToTvSpots}>
  <div class="header">View TV Spots</div>
  <div class="TV_Spot_Location_Class">
    <img src="static/icons/TV_Spot_Location_A0_Rectangle_7_pattern.png" alt="TV Spots">
  </div>
</div> -->